import Close from '@mui/icons-material/Close'
import { DialogContent, DialogTitle, Grid, IconButton } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { CustomTextArea } from 'src/consumer/components/helperComponents'
import { genericHandleChange } from 'src/consumer/helpers/utilFunctions'

export default function DiagnosisContextForm({
  item: diagnosis,
  setItem: setDiagnosis,
  saveItem,
  closeMenu,
}) {
  // Local state for text inputs — immediate display, debounced parent context update
  const [noteLocal, setNoteLocal] = useState(diagnosis?.note || '')
  const [locationLocal, setLocationLocal] = useState(diagnosis?.location || '')
  const _noteTimerRef = useRef(null)
  const _locationTimerRef = useRef(null)
  const _setDiagnosisRef = useRef(setDiagnosis)
  _setDiagnosisRef.current = setDiagnosis

  useEffect(() => { setNoteLocal(diagnosis?.note || '') }, [diagnosis?.note])
  useEffect(() => { setLocationLocal(diagnosis?.location || '') }, [diagnosis?.location])

  useEffect(() => {
    return () => {
      clearTimeout(_noteTimerRef.current)
      clearTimeout(_locationTimerRef.current)
    }
  }, [])

  function handleDrugChange(e) {
    genericHandleChange(e, setDiagnosis)
  }

  // useEffect(() => {
  //   setDiagnosis(item)
  // }, [item])

  // useEffect(() => {
  //   console.log('diagnosis', diagnosis)
  // }, [diagnosis])

  return (
    <>
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center' }}
      >
        <div>
          <span>{diagnosis?.label}</span>
        </div>
        <IconButton sx={{ flexShrink: 0 }} onClick={closeMenu}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item md={12}>
            <h5>Note</h5>
          </Grid>
          <Grid item md={12}>
            <CustomTextArea
              id="note"
              onChange={(e) => {
                const val = e.target.value
                setNoteLocal(val)
                clearTimeout(_noteTimerRef.current)
                _noteTimerRef.current = setTimeout(() => {
                  _setDiagnosisRef.current((prev) => ({ ...prev, note: val }))
                }, 300)
              }}
              value={noteLocal}
            />
          </Grid>
          <Grid item md={12}>
            <h5>Location</h5>
          </Grid>
          <Grid item md={12}>
            <CustomTextArea
              id="location"
              onChange={(e) => {
                const val = e.target.value
                setLocationLocal(val)
                clearTimeout(_locationTimerRef.current)
                _locationTimerRef.current = setTimeout(() => {
                  _setDiagnosisRef.current((prev) => ({ ...prev, location: val }))
                }, 300)
              }}
              value={locationLocal}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </>
  )
}
